export const VAT_NUMBER_REGEX = /^(GB)?([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})$/;
